(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2-distributor-form"] && !Shopify.designMode) return;
  try {
    
  /* Stamp the marker on the first line of the message at submit time. It runs only after native
     validation passes, and leaves the visitor's own text intact below it. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'distributor-form') return;
    var body = form.querySelector('[data-dist-body]');
    if (!body) return;
    var mark = '*** DISTRIBUTOR INQUIRY ***';
    if (body.value.indexOf(mark) === 0) return;
    var text = body.value.replace(/^\s+|\s+$/g, '');
    body.value = mark + (text ? '\n\n' + text : '\n\n(No message was written.)');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-quote-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FORM_ID = 'quote-form';
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var EIN_RE = /^\d{2}-?\d{7}$/;
    var ZIP_RE = /^\d{5}(-\d{4})?$/;

    function init(form) {
      if (!form || form.__quote) return;
      var msgsEl = form.querySelector('[data-quote-msgs]');
      if (!msgsEl) return; /* success state: no fields */
      form.__quote = true;
      var M = {};
      try { M = JSON.parse(msgsEl.textContent); } catch (e) {}
      form.setAttribute('novalidate', '');
      var tried = false;

      /* ---------- errors ---------- */
      function errEl(input) {
        var id = (input.getAttribute('aria-describedby') || '').split(' ')[0];
        return id ? document.getElementById(id) : null;
      }
      function setErr(input, msg) {
        var el = errEl(input);
        if (msg) {
          input.setAttribute('aria-invalid', 'true');
          if (el) { el.textContent = msg; el.hidden = false; }
        } else {
          input.removeAttribute('aria-invalid');
          if (el) { el.textContent = ''; el.hidden = true; }
        }
      }

      /* ---------- rules ---------- */
      function digits(v) { return v.replace(/\D/g, ''); }
      function phoneDigits(v) {
        var d = digits(v);
        if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
        return d;
      }
      function check(input) {
        if (input.matches(':disabled')) return ''; /* includes fields inside the disabled delivery fieldset */
        var v = (input.value || '').trim();
        switch (input.getAttribute('data-q')) {
          case 'organization': case 'name': case 'job_title': case 'street': case 'city': case 'state':
            return v ? '' : M[input.getAttribute('data-q')];
          case 'ein':
            return !v || EIN_RE.test(v) ? '' : M.ein;
          case 'email':
            return !v ? M.email_blank : (EMAIL_RE.test(v) ? '' : M.email_invalid);
          case 'phone':
            return phoneDigits(v).length === 10 && !/[a-z]/i.test(v) ? '' : M.phone;
          case 'zip':
            return ZIP_RE.test(v) ? '' : M.zip;
          case 'quantity':
            return /^\d{1,4}$/.test(v) && +v >= 1 ? '' : M.quantity;
          case 'product':
            if (!v) return M.product;
            if (input.tagName === 'SELECT') {
              var sels = form.querySelectorAll('select[data-q="product"]');
              for (var i = 0; i < sels.length; i++) {
                if (sels[i] === input) break;
                if (sels[i].value === input.value) return M.product_duplicate;
              }
            }
            return '';
        }
        return '';
      }
      function fields() { return form.querySelectorAll('[data-q]'); }
      function validateAll() {
        var first = null;
        Array.prototype.forEach.call(fields(), function (f) {
          var m = check(f);
          setErr(f, m);
          if (m && !first) first = f;
        });
        return first;
      }

      /* Re-check a field as it is fixed, once the visitor has tried to submit (or left it). */
      form.addEventListener('input', function (e) {
        var f = e.target;
        if (!f.hasAttribute || !f.hasAttribute('data-q')) return;
        if (tried || f.getAttribute('aria-invalid') === 'true') {
          setErr(f, check(f));
          if (f.getAttribute('data-q') === 'product') revalidateProducts();
        }
      });
      form.addEventListener('change', function (e) {
        var f = e.target;
        if (f.tagName === 'SELECT' && f.hasAttribute('data-q') && (tried || f.getAttribute('aria-invalid') === 'true')) {
          setErr(f, check(f));
          if (f.getAttribute('data-q') === 'product') revalidateProducts();
        }
      });
      form.addEventListener('focusout', function (e) {
        var f = e.target;
        if (!f.hasAttribute || !f.hasAttribute('data-q')) return;
        if (f.tagName === 'SELECT') return;
        if ((f.value || '').trim() !== '') setErr(f, check(f));
      });
      function revalidateProducts() {
        Array.prototype.forEach.call(form.querySelectorAll('select[data-q="product"]'), function (s) {
          if (tried || s.getAttribute('aria-invalid') === 'true') setErr(s, check(s));
        });
      }

      /* ---------- product lines ---------- */
      var list = form.querySelector('[data-quote-lines]');
      var addBtn = form.querySelector('[data-quote-add]');
      var addNote = form.querySelector('[data-quote-addnote]');
      var max = parseInt(list && list.getAttribute('data-max'), 10) || 1;
      function lines() { return list ? list.querySelectorAll('[data-quote-line]') : []; }
      function renumber() {
        var ls = lines();
        Array.prototype.forEach.call(ls, function (line, i) {
          var n = i + 1;
          line.setAttribute('aria-label', 'Product line ' + n);
          [['product', 'q-product-'], ['qty', 'q-qty-']].forEach(function (k) {
            var f = line.querySelector(k[0] === 'qty' ? '[data-q="quantity"]' : '[data-q="product"]');
            var err = line.querySelector('[data-err-for="' + k[0] + '"]');
            var lbl = line.querySelector('[data-line-for="' + k[0] + '"]');
            if (!f) return;
            f.id = k[1] + n;
            f.name = 'contact[' + (k[0] === 'qty' ? 'Quantity ' : 'Product ') + n + ']';
            f.setAttribute('aria-describedby', k[1] + n + '-err');
            if (err) err.id = k[1] + n + '-err';
            if (lbl) lbl.setAttribute('for', f.id);
          });
          var rm = line.querySelector('[data-quote-remove]');
          if (rm) { rm.hidden = ls.length < 2; rm.setAttribute('aria-label', 'Remove product line ' + n); }
        });
        if (addNote && ls.length < max) addNote.textContent = '';
      }
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var ls = lines();
          /* The control stays visible; once every product has a line it explains why nothing was added. */
          if (ls.length >= max) { if (addNote) addNote.textContent = M.all_added || ''; return; }
          var clone = ls[0].cloneNode(true);
          Array.prototype.forEach.call(clone.querySelectorAll('[data-q]'), function (f) {
            f.value = f.getAttribute('data-q') === 'quantity' ? '1' : '';
            if (f.tagName === 'SELECT') f.selectedIndex = 0;
            setErr(f, '');
          });
          Array.prototype.forEach.call(clone.querySelectorAll('.v2-quote__err'), function (p) { p.textContent = ''; p.hidden = true; });
          /* Preselect the first product not already chosen, so the new line is useful at once. */
          var sel = clone.querySelector('select[data-q="product"]');
          if (sel) {
            var used = {};
            Array.prototype.forEach.call(form.querySelectorAll('select[data-q="product"]'), function (s) { if (s.value) used[s.value] = 1; });
            for (var i = 1; i < sel.options.length; i++) { if (!used[sel.options[i].value]) { sel.selectedIndex = i; break; } }
          }
          list.appendChild(clone);
          renumber();
          (sel || clone.querySelector('input')).focus();
        });
      }
      if (list) {
        list.addEventListener('click', function (e) {
          var step = e.target.closest && e.target.closest('[data-step]');
          if (step) {
            var q = step.parentNode.querySelector('[data-q="quantity"]');
            var v = parseInt(q.value, 10);
            if (isNaN(v)) v = 0;
            v = Math.min(9999, Math.max(1, v + parseInt(step.getAttribute('data-step'), 10)));
            q.value = String(v);
            q.dispatchEvent(new Event('input', { bubbles: true }));
            return;
          }
          var rm = e.target.closest && e.target.closest('[data-quote-remove]');
          if (!rm) return;
          var line = rm.closest('[data-quote-line]');
          var ls = Array.prototype.slice.call(lines());
          if (ls.length < 2) return;
          var idx = ls.indexOf(line);
          line.parentNode.removeChild(line);
          renumber();
          revalidateProducts();
          var now = lines();
          var target = now[Math.max(0, idx - 1)];
          var focusTo = target && target.querySelector('[data-q="product"]');
          (focusTo || addBtn || form).focus();
        });
      }
      renumber();

      /* ---------- same as billing ---------- */
      var same = form.querySelector('[data-quote-same]');
      var sameVal = form.querySelector('[data-quote-same-value]');
      var delivery = form.querySelector('[data-quote-delivery]');
      function syncSame() {
        if (!same || !delivery) return;
        delivery.hidden = same.checked;
        delivery.disabled = same.checked;
        if (sameVal) sameVal.value = same.checked ? 'Same as billing' : 'Different from billing, see below';
        if (same.checked) Array.prototype.forEach.call(delivery.querySelectorAll('[data-q]'), function (f) { setErr(f, ''); });
      }
      if (same) { same.addEventListener('change', function () { syncSame(); if (!same.checked) { var f = delivery.querySelector('input'); if (f) f.focus(); } }); syncSame(); }

      /* ---------- tax exempt ---------- */
      var tax = form.querySelector('[data-quote-tax]');
      var taxVal = form.querySelector('[data-quote-tax-value]');
      var taxNote = form.querySelector('[data-quote-tax-note]');
      function syncTax() {
        if (!tax) return;
        if (taxNote) taxNote.textContent = tax.checked ? (M.tax_note || '') : '';
        if (taxVal) taxVal.value = tax.checked ? 'Yes. Ask them for a copy of the tax exemption certificate.' : 'No';
      }
      if (tax) { tax.addEventListener('change', syncTax); syncTax(); }

      /* ---------- submit ----------
         Capture phase on document, so this runs before Shopify's own submit listeners: an invalid
         form is stopped before any CAPTCHA step starts. */
      form.__quoteSubmit = function (e) {
        tried = true;
        syncSame(); syncTax();
        var first = validateAll();
        if (first) {
          e.preventDefault();
          e.stopImmediatePropagation();
          first.focus();
          return;
        }
        /* Normalize what the email shows. */
        var ein = form.querySelector('[data-q="ein"]');
        if (ein && ein.value.trim()) { var d = digits(ein.value); ein.value = d.slice(0, 2) + '-' + d.slice(2); }
        var ph = form.querySelector('[data-q="phone"]');
        if (ph) { var p = phoneDigits(ph.value); ph.value = '(' + p.slice(0, 3) + ') ' + p.slice(3, 6) + '-' + p.slice(6); }
        Array.prototype.forEach.call(form.querySelectorAll('[data-q]'), function (f) { if (f.tagName !== 'SELECT' && !f.matches(':disabled')) f.value = f.value.trim(); });
        var body = form.querySelector('[data-quote-body]');
        var mark = '*** QUOTE REQUEST ***';
        if (body && body.value.indexOf(mark) !== 0) {
          var text = body.value.replace(/^\s+|\s+$/g, '');
          body.value = mark + (text ? '\n\n' + text : '\n\n(No notes were written.)');
        }
      };
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id !== FORM_ID) return;
      init(form);
      if (form.__quoteSubmit) form.__quoteSubmit(e);
    }, true);

    function boot() { init(document.getElementById(FORM_ID)); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
